import { bool, string, func } from 'prop-types';

export default {
    isSellerOnline: bool,
    isCardHovered: bool,
    source: string,
    showJobTitle: bool,
    onClick: func,
};
